export default __webpack_public_path__ + "static/Prostatizal-desktop-2a0a58031b131a69f19dbe450363fc40.jpg";